/**
 * @generated SignedSource<<86df45d6616b90c5ccd88954bdac60af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardTransitionZones_query$data = {
  readonly jira_categoryField: {
    readonly displayName: string;
    readonly fieldId: string;
  } | null | undefined;
  readonly " $fragmentType": "BoardTransitionZones_query";
};
export type BoardTransitionZones_query$key = {
  readonly " $data"?: BoardTransitionZones_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardTransitionZones_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "BoardTransitionZones_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlField",
      "kind": "LinkedField",
      "name": "jira_categoryField",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "fieldId"
          },
          "action": "THROW",
          "path": "jira_categoryField.fieldId"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "displayName"
          },
          "action": "THROW",
          "path": "jira_categoryField.displayName"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "b8d6dfef24e5a9e8ccfbece0bc1b13d8";

export default node;
